import { AddressDto } from 'src/app/_shared/dtos/address.dto';

export class OrganizationInputDto {
  name: string;
  logo?: string;
  address: AddressDto;
}
